import React from 'react';

function Test(props) {
    return (
        <div>
            Test
        </div>
    );
}

export default Test;